import './styles/App.css';
import './styles/Site.css';
import {HashRouter as Router, Routes, Route, useLocation} from 'react-router-dom';
import {
    FluentProvider,
    webLightTheme,
    Dialog,
    DialogSurface,
    DialogBody,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from '@fluentui/react-components';
import {isClubDataAvailable, isLoggedIn} from "./handlers/userhandler";
import EventView from "./pages/EventView";
import ParticipantsView from "./pages/ParticipantsView";
import RegisterView from "./pages/RegisterView";
import {handleClubDataPages, handleLoginPages} from "./handlers/routehandler";
import {useEffect, useState} from "react";
import ChangeAccount from "./pages/ChangeAccount";
import HomeView from "./pages/HomeView";
import SideNavBar from "./components/SideNavBar";
import LoginView from "./pages/LoginView";
import ScheduleView from "./pages/ScheduleView";
import LiveScheduleView from "./pages/LiveScheduleView";
import PrivacyView from "./pages/PrivacyView";
import ManualView from "./pages/ManualView";
import { navigateToPage } from './handlers/routehandler';

export default function App() {
    const [showClubDataDialog, setShowClubDataDialog] = useState(false);

    function RouteChangeHandler() {
        const location = useLocation();

        useEffect(() => {
            isLoggedIn().then(loggedIn => {
                handleLoginPages(loggedIn);

                if (loggedIn) {
                    isClubDataAvailable().then((result) => {
                        handleClubDataPages(result, setShowClubDataDialog);
                    });
                }
            });
        }, [location]);

        return null;
    }

    return (
        <FluentProvider theme={webLightTheme} className={`bg-gradient`}>
            <Router>
                <RouteChangeHandler />
                <div className={`app-container`}>
                    <Dialog open={showClubDataDialog} onOpenChange={setShowClubDataDialog}>
                        <DialogSurface>
                            <DialogBody>
                                <DialogTitle>Verenigingsinformatie ontbreekt</DialogTitle>
                                <DialogContent>
                                    Het lijkt erop dat je je verenigingsgegevens nog niet hebt ingevoerd. Voer deze in om verder te gaan.
                                </DialogContent>
                                <DialogActions>
                                    <Button as={`a`} className={`button`} onClick={() => setShowClubDataDialog(false)} appearance="secondary">Annuleren</Button>
                                    <Button as={`a`} className={`button`} onClick={() => {
                                        setShowClubDataDialog(false);
                                        navigateToPage(`create-account`);
                                    }} appearance="primary">Ga naar verenigingsgegevens</Button>
                                </DialogActions>
                            </DialogBody>
                        </DialogSurface>
                    </Dialog>
                    <SideNavBar/>
                    <Routes>
                        <Route path="/" element={<HomeView/>}/>
                        <Route path="/:id" element={<EventView/>}/>
                        <Route path="/:id/register" element={<RegisterView/>}/>
                        <Route path="/login" element={<LoginView/>}/>
                        <Route path="/create-account" element={<ChangeAccount isNew={true} />}/>
                        <Route path="/participants" element={<ParticipantsView/>}/>
                        <Route path="/account" element={<ChangeAccount/>}/>
                        <Route path="/:id/schedule" element={<ScheduleView/>}/>
                        <Route path="/:id/live" element={<LiveScheduleView/>}/>
                        <Route path="/privacy" element={<PrivacyView/>}/>
                        <Route path="/manual" element={<ManualView/>}/>
                    </Routes>
                </div>
            </Router>
        </FluentProvider>
    );
}